/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// UI lib components
import { LanguageSelect } from '@components/v2/ui/LanguageSelect/LanguageSelect';
import { useBreakpoint } from '@hooks/useBreakpoint';
import { useLocalStorage } from '@hooks/useLocalStorage';
import {
	BackgroundImage,
	Flex,
	Image,
} from '@mantine/core';
import { LANG_OPTIONS } from '@utils/options';
import { useTranslation } from 'react-i18next';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const BackgroundImageAuth = ({
	url,
	urlPartner,
}: {
	url: string;
	urlPartner?: string;
}) => {
	const [language, setLanguage] = useLocalStorage<string>(
		'lng',
		'fr'
	);

	const { i18n } = useTranslation();

	const { isMobile } = useBreakpoint();

	const handleLanguageChange = (lng: string) => {
		setLanguage(lng);
		i18n.changeLanguage(lng);
	};

	/* ******************************** RENDERING ******************************* */
	return (
		<BackgroundImage
			src={url}
			radius={isMobile ? '0px' : 'lg'}
			p={'24px'}
		>
			<Flex
				flex={1}
				justify={
					urlPartner ? 'space-between' : 'flex-end'
				}
			>
				{urlPartner && (
					<Image
						mah={isMobile ? '101px' : '118px'}
						maw={isMobile ? '101px' : '118px'}
						mih={isMobile ? '101px' : '118px'}
						miw={isMobile ? '101px' : '118px'}
						radius="md"
						fit="contain"
						src={urlPartner}
					/>
				)}

				<LanguageSelect
					value={language}
					onChange={handleLanguageChange}
					options={LANG_OPTIONS}
					width={170}
					fullWidth={false}
				/>
			</Flex>
		</BackgroundImage>
	);
};
